module.exports = __webpack_public_path__ + "img/720t.bca4cd4e.png";